import localities from './localidades.json';

export type cityDataType = {
  idLocalidad: number;
  nombrePartido: string;
  nombreLocalidad: string;
  nombreProvincia: string;
};

type CityDataModel = {
  filters: Partial<Record<keyof cityDataType, string>>;
  targetKey: keyof cityDataType;
};

export const getCityData = async ({ filters, targetKey }: CityDataModel): Promise<string[]> => {
  return Promise.resolve(
    Array.from(
      localities.reduce((acc, item) => {
        const matchesAll = Object.entries(filters).every(
          ([filterKey, filterValue]) => item[filterKey as keyof cityDataType] === filterValue,
        );
        if (matchesAll) {
          acc.add(item[targetKey] as string);
        }
        return acc;
      }, new Set<string>()),
    ),
  );
};

export const getCityDataById = async (id: number): Promise<cityDataType | undefined> => {
  return Promise.resolve(localities?.find((locality) => locality.idLocalidad === id));
};

export const getIdByCityData = async (props: Omit<cityDataType, 'idLocalidad'>): Promise<number | undefined> => {
  const { nombreProvincia, nombrePartido, nombreLocalidad } = props;
  const localityData = localities.find(
    (locality) =>
      locality.nombreProvincia === nombreProvincia &&
      locality.nombrePartido === nombrePartido &&
      locality.nombreLocalidad === nombreLocalidad,
  );
  return Promise.resolve(localityData?.idLocalidad);
};
